/* Andy Cooks – cooking glossary on recipe pages.
   Terms come from the Recipes by Andy "Cooking Term" glossary (metaobject cooking_term), printed into the page as JSON
   by sections/ac-recipe-card.liquid (#acg-terms). The first time each term appears in the directions or anything below them
   (equipment, chef's tips, FAQs, about) in its cooking sense it gets a dotted orange underline; hover, tap or focus it to see a little bubble with the meaning. */
(function () {
  'use strict';
  var acT = function (k, f, v) { var s = (window.AC_I18N && window.AC_I18N[k]) || f; if (v) { for (var n in v) { s = s.split('__' + n + '__').join(v[n]); } } return s; };
  if (window.__acGlossary) return;
  window.__acGlossary = true;

  var CSS =
    '.acg{position:relative;display:inline;padding:0 1px;margin:0;border:0;background:none;font:inherit;color:inherit;line-height:inherit;letter-spacing:inherit;text-transform:inherit;text-align:inherit;cursor:help;' +
      'background-image:linear-gradient(90deg,var(--ac-orange,#FE7519) 50%,transparent 50%);background-size:6px 2px;background-repeat:repeat-x;background-position:0 100%;' +
      'border-radius:3px;transition:background-color .15s ease,color .15s ease;-webkit-tap-highlight-color:transparent}' +
    '.acg:hover,.acg:focus-visible,.acg.is-open{background-color:#FFF1E6;outline:0}' +
    '.acg::after{content:"";position:absolute;top:-3px;right:-5px;width:6px;height:6px;border-radius:50%;background:var(--ac-orange,#FE7519);opacity:0;transform:scale(.4)}' +
    '.acg.is-seen::after{animation:acgPing 1.6s ease-out .2s 2}' +
    '.acg.is-seen{animation:acgGlow 1.4s ease .1s 1}' +
    '@keyframes acgPing{0%{opacity:0;transform:scale(.4)}20%{opacity:1;transform:scale(1)}60%{opacity:.9;transform:scale(1.15)}100%{opacity:0;transform:scale(1.9)}}' +
    '@keyframes acgGlow{0%,100%{background-color:transparent}35%{background-color:#FFE3CC}}' +
    '.acg-tip{position:fixed;z-index:2147482600;left:0;top:0;width:max-content;max-width:min(320px,calc(100vw - 24px));padding:14px 16px 15px;border-radius:16px;background:#000;color:#fff;' +
      'font:400 14px/1.5 var(--ac-font,inherit);box-shadow:0 18px 40px -12px rgba(0,0,0,.45);opacity:0;transform:translateY(6px) scale(.98);transform-origin:50% 100%;' +
      'transition:opacity .16s ease,transform .16s ease;pointer-events:none;text-align:left;text-transform:none;letter-spacing:0}' +
    '.acg-tip.is-on{opacity:1;transform:none;pointer-events:auto}' +
    '.acg-tip.is-below{transform-origin:50% 0}' +
    '.acg-tip__k{display:flex;align-items:center;gap:7px;margin:0 0 6px;font-size:11px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;color:var(--ac-orange,#FE7519)}' +
    '.acg-tip__k svg{width:14px;height:14px;flex:none;fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}' +
    '.acg-tip__t{display:block;margin:0 0 4px;font-size:17px;font-weight:600;line-height:1.2;color:#fff;text-transform:capitalize}' +
    '.acg-tip__d{margin:0;color:#e4e4e4}' +
    '.acg-tip__arrow{position:absolute;width:14px;height:14px;background:#000;transform:rotate(45deg);border-radius:2px}' +
    '@media (prefers-reduced-motion:reduce){.acg.is-seen,.acg.is-seen::after{animation:none}.acg-tip{transition:none}}' +
    '@media print{.acg{background:none!important}.acg::after{display:none}.acg-tip{display:none!important}}';

  function init() {
    var data = document.getElementById('acg-terms');
    var root = document.querySelector('[data-acr]');
    if (!data || !root) return;
    var terms;
    try { terms = JSON.parse(data.textContent || '[]'); } catch (e) { return; }
    terms = (terms || []).filter(function (x) { return x && x.t && x.d; });
    if (!terms.length) return;

    var style = document.createElement('style');
    style.textContent = CSS;
    document.head.appendChild(style);

    /* "sauté" also matches saute, sauteed, sautéing; "crystallised" also matches crystallise, crystallisation */
    var ACC = { a: '[aàáâä]', e: '[eèéêë]', i: '[iìíîï]', o: '[oòóôö]', u: '[uùúûü]', c: '[cç]', n: '[nñ]' };
    function fold(s) { return s.normalize ? s.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : s; }
    function pattern(term) {
      var t = fold(term.toLowerCase().trim()).replace(/\s+/g, ' ');
      function esc(x) { return x.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/[aeiounc]/g, function (ch) { return ACC[ch]; }).replace(/ /g, '[\\s-]+'); }
      /* hard stop: match the whole term (plus a normal ending: seared, resting, folds) ... */
      var alts = [esc(t) + '(?:s|es|d|ed|ing)?'];
      /* ... or its stem, but only with an ending attached, so "Frenched" never matches plain "French"
         while "Sauté" still matches sautéed / sautéing and "Caramelise" matches caramelised */
      var stem = t.replace(/(ations?|ing|ed|es|s|e|d)$/, '');
      if (stem.length >= 4 && !/\s/.test(t) && stem !== t) alts.push(esc(stem) + '(?:[eé]|[eé]d|[eé]s|ing|ations?|[eé]ed)');
      var body = '(?:' + alts.join('|') + ')';
      try { return new RegExp('(?<![\\p{L}\\p{N}])' + body + '(?![\\p{L}\\p{N}])', 'iu'); }
      catch (e) { return new RegExp('\\b' + body + '\\b', 'i'); }
    }
    /* everyday words that are only glossary terms in the cooking sense: read the words around the match first.
       "let it rest" is the term, "the rest keeps going" is not; "reduce the sauce" yes, "reduce the heat" no;
       "mince the garlic" yes, "beef mince" no; "season well" yes, "in season" no; "fold in the flour" yes, "fold in half" no */
    var DET = '(?:the|a|an|any|all|some|this|that|these|those|its|their|your|our|remaining|whatever)';
    var CONTEXT = {
      rest: { before: new RegExp('\\b' + DET + '\\s+$', 'i'), after: /^\s+of\b/i },
      reduce: { after: /^\s+(?:the\s+|your\s+)?(?:heat|temperature|temp|flame|oven|gas|speed)\b/i },
      mince: { before: new RegExp('\\b(?:' + DET.slice(3, -1) + '|beef|pork|lamb|chicken|veal|turkey|kangaroo|venison|of|with|and)\\s+$', 'i'), after: /^\s+(?:meat|pies?)\b/i },
      season: { before: /\b(?:in|out\s+of|this|that|the|each|every|whole|festive|holiday|christmas|summer|winter|spring|autumn|fall|bbq|footy|cricket|grilling)\s+$/i, after: /^(?:'|\u2019)s\b/i },
      fold: { after: /^\s+(?:it\s+|them\s+|(?:in\s+)?the\s+\w+\s+)?(?:in\s+half|over|up|into\s+(?:half|halves|thirds|quarters|a\s+\w+))\b|^\s+(?:in\s+)?the\s+(?:edges|sides|corners|ends|wrapper|pastry|top|bottom)\b/i }
    };
    function okHere(term, before, after) {
      var r = CONTEXT[fold(term.toLowerCase().trim())];
      if (!r) return true;
      if (r.before && r.before.test(before)) return false;
      if (r.after && r.after.test(after)) return false;
      return true;
    }
    function allMatches(re, text) {
      var g = new RegExp(re.source, re.flags.indexOf('g') < 0 ? re.flags + 'g' : re.flags), out = [], m;
      while ((m = g.exec(text))) { out.push(m); if (!m[0].length) g.lastIndex++; }
      return out;
    }
    var list = terms.map(function (x) { return { t: x.t, d: x.d, re: pattern(x.t) }; })
      .sort(function (a, b) { return b.t.length - a.t.length; });   /* longer phrases first ("brown butter" before "butter") */

    /* directions and everything below them only (equipment, chef's tips, FAQs, about); never the title, short description or ingredients */
    var scopes = root.querySelectorAll('#acr-directions .acr-steps li, .acr-body .acr-notes');
    var SKIP = 'a, button, .acg, .acr-num, .acr-sr, .acr-conv, h1, h2, summary, script, style';
    var done = {};
    [].forEach.call(scopes, function (scope) {
      list.forEach(function (term) {
        if (done[term.t]) return;
        var full = scope.textContent, pos = 0;   /* the whole step / section, so words either side are read even across bold or links */
        var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, null), node;
        while ((node = walker.nextNode())) {
          var at = pos;
          pos += node.nodeValue.length;
          if (!node.nodeValue.trim() || (node.parentNode.closest && node.parentNode.closest(SKIP))) continue;
          var m = null;
          allMatches(term.re, node.nodeValue).some(function (x) {
            var i = at + x.index;
            if (okHere(term.t, full.slice(Math.max(0, i - 40), i), full.slice(i + x[0].length, i + x[0].length + 40))) { m = x; return true; }
            return false;
          });
          if (!m) continue;
          var hit = node.splitText(m.index);
          hit.splitText(m[0].length);
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'acg';
          b.setAttribute('aria-expanded', 'false');
          b.setAttribute('aria-label', acT('ac.js.glossary.what_means', '__term__: what does this mean?', { term: m[0] }));
          b.dataset.t = term.t;
          b.dataset.d = term.d;
          b.textContent = m[0];
          hit.parentNode.replaceChild(b, hit);
          done[term.t] = true;
          break;
        }
      });
    });

    var btns = [].slice.call(root.querySelectorAll('.acg'));
    if (!btns.length) return;

    /* a little ping the first time each term scrolls into view */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-seen'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -15% 0px' });
      btns.forEach(function (b) { io.observe(b); });
    }

    /* the bubble */
    var tip = document.createElement('div');
    tip.className = 'acg-tip';
    tip.id = 'acg-tip';
    tip.setAttribute('role', 'tooltip');
    tip.innerHTML = '<p class="acg-tip__k"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H20v15H6.5A2.5 2.5 0 0 0 4 20.5z"/><path d="M4 20.5A2.5 2.5 0 0 1 6.5 18H20v3H6.5A2.5 2.5 0 0 1 4 20.5z"/></svg>' + acT('ac.js.glossary.kitchen_glossary', 'Kitchen glossary') + '</p>' +
      '<b class="acg-tip__t"></b><p class="acg-tip__d"></p><span class="acg-tip__arrow" aria-hidden="true"></span>';
    document.body.appendChild(tip);
    var cur = null, pinned = false, hideT = null;

    function place(b) {
      var r = b.getClientRects()[0] || b.getBoundingClientRect(), tw = tip.offsetWidth, th = tip.offsetHeight, gap = 12, vw = document.documentElement.clientWidth;
      var below = r.top - th - gap < 8;
      var left = Math.max(12, Math.min(vw - tw - 12, r.left + r.width / 2 - tw / 2));
      var top = below ? r.bottom + gap : r.top - th - gap;
      tip.style.left = left + 'px';
      tip.style.top = top + 'px';
      tip.classList.toggle('is-below', below);
      var arrow = tip.querySelector('.acg-tip__arrow');
      arrow.style.left = Math.max(14, Math.min(tw - 28, r.left + r.width / 2 - left - 7)) + 'px';
      arrow.style.top = below ? '-6px' : (th - 8) + 'px';
    }
    function show(b, pin) {
      clearTimeout(hideT);
      if (cur && cur !== b) { cur.classList.remove('is-open'); cur.setAttribute('aria-expanded', 'false'); cur.removeAttribute('aria-describedby'); }
      cur = b; pinned = !!pin;
      tip.querySelector('.acg-tip__t').textContent = b.dataset.t;
      tip.querySelector('.acg-tip__d').textContent = b.dataset.d;
      b.classList.add('is-open'); b.setAttribute('aria-expanded', 'true'); b.setAttribute('aria-describedby', 'acg-tip');
      tip.classList.add('is-on');
      place(b);
    }
    function hide(now) {
      clearTimeout(hideT);
      hideT = setTimeout(function () {
        tip.classList.remove('is-on');
        if (cur) { cur.classList.remove('is-open'); cur.setAttribute('aria-expanded', 'false'); cur.removeAttribute('aria-describedby'); }
        cur = null; pinned = false;
      }, now ? 0 : 140);
    }

    var hoverable = window.matchMedia && window.matchMedia('(hover: hover)').matches;
    btns.forEach(function (b) {
      if (hoverable) {
        b.addEventListener('mouseenter', function () { show(b, false); });
        b.addEventListener('mouseleave', function () { if (!pinned) hide(); });
      }
      b.addEventListener('focus', function () { show(b, false); });
      b.addEventListener('blur', function () { if (!pinned) hide(); });
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();   /* don't also tick off the step it sits in */
        if (cur === b && pinned) hide(true); else show(b, true);
      });
    });
    tip.addEventListener('mouseenter', function () { clearTimeout(hideT); });
    tip.addEventListener('mouseleave', function () { if (!pinned) hide(); });
    document.addEventListener('click', function (e) { if (cur && !tip.contains(e.target) && !e.target.closest('.acg')) hide(true); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && cur) { var b = cur; hide(true); b.focus(); } });
    window.addEventListener('scroll', function () { if (cur) place(cur); }, { passive: true });
    window.addEventListener('resize', function () { if (cur) place(cur); });
  }

  /* loaded (deferred) after ac-recipe-card.js, so the measurements in the steps are already wrapped */
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
